import { CallToAction, Heading, NewsGridSection } from '@stereoagency/ui';
import flush from 'just-flush';
import useTranslation from 'next-translate/useTranslation';
import { FiArrowRight } from 'react-icons/fi';
import { useContext } from 'react';
import { articleAsProps } from '@/utils';
import { relatedArticlesQuery } from './groupOrPlatformSubqueries';
import { SpecialPagesContext } from '@/components/context';

type Props = {
  articles?: (typeof relatedArticlesQuery)[1];
};

export default function GroupOrPlatformNewsGrid({ articles }: Props) {
  const { t, lang } = useTranslation('research-group-or-platform');
  const { pages } = useContext(SpecialPagesContext);

  if (!articles?.length) {
    return null;
  }

  return (
    <div>
      <div className="flex justify-between items-center flex-wrap mb-7 md:mb-9">
        <Heading id="news" as="h2" variant="h2">
          {t('sections.news.title')}
        </Heading>
        {pages.news_listing_page && (
          <CallToAction
            buttonType="icon-after"
            variant="button/secondary"
            className="ml-5"
            icon={<FiArrowRight />}
            href={pages.news_listing_page.href}
            label={t('sections.news.action.label')}
          />
        )}
      </div>

      <NewsGridSection
        variant="narrow"
        cards={flush(
          articles.map((article) => articleAsProps(article, lang, { pages }))
        )}
      />
    </div>
  );
}
